import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";
import { IInventoryType } from "./types";

type Props = {
  inventories: IInventoryType[];
};

export const InventoryViewer = ({ inventories }: Props) => {
  if (inventories?.length === 0) {
    return null;
  }
  return (
    <div>
      {inventories?.map((inv) => {
        return (
          <Flex key={inv._id} direction="column" gap={"4px"}>
            <Flex alignItems="center">
              <Typography fontWeight="bold">Title:</Typography>
              <Typography size={"title"} color="dark.black">
                {inv?.title}
              </Typography>
            </Flex>
            <Flex alignItems="center">
              <Typography fontWeight="bold">Quantity:</Typography>
              <Typography size={"title"} color="dark.black">
                {inv?.quantity}
              </Typography>
            </Flex>
            <Flex alignItems="center">
              <Typography fontWeight="bold">Description:</Typography>
              <Typography size={"title"} color="dark.black">
                {inv?.description}
              </Typography>
            </Flex>
            <Flex direction="column">
              <Typography fontWeight="bold">Images:</Typography>
              <Flex gap={"20px"}>
                {inv?.images?.map((i) => {
                  return (
                    <img
                      src={i}
                      alt="inventory"
                      style={{ height: "180px", width: "220px" }}
                    />
                  );
                })}
              </Flex>
            </Flex>
          </Flex>
        );
      })}
    </div>
  );
};
